import { Injectable } from '@angular/core';
import { environment as prodEnv } from '@environments/environment.prod';
import { environment as stgEnv } from '@environments/environment.stg';
import { environment as devEnv } from '@environments/environment.dev';
import { environment as qaEnv } from '@environments/environment.qa';
import { environment as localEnv } from '@environments/environment.local';

interface EnvironmentConfig {  
  env: typeof prodEnv; // Assuming all imported environments have the same shape as prodEnv  
  name: string;  
}  

@Injectable({
  providedIn: 'root',
})
export class RuntimeEnvironmentService {
  private readonly envMap: ReadonlyMap<string, EnvironmentConfig> = new Map([
    ['-stg', { env: stgEnv, name: 'staging' }],
    ['-dev', { env: devEnv, name: 'development' }],
    ['-qa', { env: qaEnv, name: 'qa' }],
    ['localhost', { env: localEnv, name: 'local' }]
  ]);

  private currentEnv: any;
  private currentEnvName: any;

  constructor() {
    this.getEnvironmentByHostname();
  }

  private getEnvironmentByHostname(): void {
    const hostname = window.location.hostname;
    const envKey = Array.from(this.envMap.keys()).find(key => hostname.includes(key));
    const config = envKey ? this.envMap.get(envKey) : { env: prodEnv, name: 'production' };
    console.log(`RuntimeEnvironmentService: Detected environment - ${config!.name}`);
    this.currentEnv = config!.env;
    this.currentEnvName = config!.name;
  }

  get environment(): any {
    return this.currentEnv;
  }

  get environmentName(): string {
    return this.currentEnvName;
  }

  get gtmId(): string {
    return this.currentEnv.gtmId || '';
  }

  get gtmIdNs(): string {
    return this.currentEnv.gtmId_ns || '';
  }

  get gtmScriptUrl(): string {
    return this.currentEnv.gtmScriptUrl;
  }

  get gtmNoScriptUrl(): string {
    return this.currentEnv.gtmNoScriptUrl;
  }
}
